import { Component, OnInit, inject } from '@angular/core';
import { AuthService, DeleteLocalCacheCategory, SharedService } from '@cfp/core';

@Component({
  selector: 'cfp-demo-login-page',
  template: ''
})
export class DemoLoginPage implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly sharedService = inject(SharedService);

  public ngOnInit(): void {
    this.sharedService.emitDeleteLocalCache(DeleteLocalCacheCategory.All);
    this.login();
  }

  protected login(): void {
    this.authService.demoLogin().subscribe();
  }
}
